module.exports = __webpack_public_path__ + "static/media/add games.42e5a41e.svg";